module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_23.cb84bc24.png";